import * as $ from "jquery";
import * as Modernizr from "../../lib/modernizr-3.5.0.min.js";
declare global {
	interface Window {
		dataLayer:any;
	}
}

export function init(): void {
	// Init mobile navigation panel
	let $siteNav = $('.js-site-nav');
	let $mainNav = $('.js-main-nav');

	$('.js-main-nav-toggle').on('click', function (e) {
		e.preventDefault();

		// Hide the search if it's open
		$('body').trigger('hideSearch');

		$('body').toggleClass('state-nav-open');
		$siteNav.toggleClass('state-visible');
	});

	function trackTopLevelNavClick(navLinkText){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'clickText' : navLinkText, //Insert the text of the main navigation item
			'event' : 'main_navigation'
		});

		console.log(window.dataLayer);
	}

	// Init sub-navigation
	function closeAllSubNav(e: Event) {
		let $allSubNav = $('.js-sub-nav');
		let $target = $(e.target);

		let $closestSubnav = $target.closest('.js-sub-nav');

		if (e.type === 'click' && $closestSubnav.length) {
			return;
		}

		if ($allSubNav.filter('.state-visible').length) {
			$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			$allSubNav.removeClass('state-visible');
			$('body').removeClass('state-nav-open');
		}

		// Cancel the delayed mouseenter handler if it has been set
		$('.js-sub-nav-trigger').data('hovered', false);
	}

	if($('.hero-image--absolute').length) {
		$mainNav.addClass('main-nav--reversed');
		$('.js-header-search').addClass('quick-search-box--reversed');
		$('.site-header__nav-toggle').addClass('site-header__nav-toggle--reversed');
	}

	if (Modernizr.coarsepointer) {
		// Desktop tap-on / tap-off operation
		$('.js-sub-nav-trigger').on('click', function (e) {
			let $this = $(this);
			if (!$this.hasClass('state-sub-nav-open')) {
				e.preventDefault();
				e.stopPropagation(); // Prevent this event from bubbling and triggering the close handler
			} else {
				$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			}

			// Hide other open navs and show this nav
			$('.js-sub-nav-trigger').not(this).removeClass('state-sub-nav-open');
			$(this).toggleClass('state-sub-nav-open');

			let $closestSubNav = $(this).closest('.js-main-nav-item').find('.js-sub-nav');
			$closestSubNav.toggleClass('state-visible');
			$('.js-sub-nav').not($closestSubNav).removeClass('state-visible');

			trackTopLevelNavClick($this.text());
		});

		// Desktop tap-to-close
		$('.js-sub-nav-close').on('click', function(e) {
			$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			$('.js-sub-nav').removeClass('state-visible');
		});

		// Mobile expand/collapse operation
		$('.js-sub-nav-mobile-trigger').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			var $trigger = $(this).closest('.js-sub-nav-trigger');
			// Hide other open navs and show this nav
			$('.js-sub-nav-trigger').not($trigger).removeClass('state-sub-nav-open');
			$trigger.toggleClass('state-sub-nav-open');

			let $closestSubNav = $trigger.closest('.js-main-nav-item').find('.js-sub-nav');
			$closestSubNav.toggleClass('state-visible');
			$('.js-sub-nav').not($closestSubNav).removeClass('state-visible');

			// Scroll to selected trigger
			var siteNavTop = $('.js-site-nav').get(0).scrollTop;
			var scrollOffset = $trigger.position().top - siteNavTop;

			$siteNav.animate({
				scrollTop: scrollOffset
			}, 250);
		});

		$('body').on('click', closeAllSubNav);
	} else {
		// Delayed hover operation: the megamenu covers a lot of the screen and is easy to trigger accidentally
		// Wait 250ms and if the user is still hovering, open the nav
		$('.js-sub-nav-trigger').on('mouseenter', function () {
			let linkText = $(this).text();
			// The closeAllSubnav() function (called on mouseleave) removes this property
			$(this).data('hovered', true);

			setTimeout(() => {
				if ($(this).data('hovered')) {
					$(this).addClass('state-sub-nav-open');
					$(this).closest('.js-main-nav-item').find('.js-sub-nav').addClass('state-visible');
				}
			}, 250);
		});

		$('.js-main-nav-item').on('mouseleave', closeAllSubNav);
		$('body').on('click', closeAllSubNav);
	}

	$('body').on('click.flyoutmenus', '.js-sub-nav a', function(e){
		let $this = $(this);
		let $content = $this.text().trim();
		trackTopLevelNavClick($content);
	});

	//Google Tag Manager Tracking
	function trackQuickSearch(searchQuery) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'searchText' : searchQuery, //Insert the model number that was searched
			'event' : 'modelnum_searched_main'
		});
		console.log(window.dataLayer);
	}

	//track quick search analytics
	$('.menu-quick-search').on('submit', function(){
		let $this = $(this);
		let inputValue = $this.find('input[type="text"]:first').val();
		trackQuickSearch(inputValue);
	});
}



// WEBPACK FOOTER //
// ./js/PFF/modules/nav.ts